export default __webpack_public_path__ + "static/eingewoehnung-8f35fb0d69359f55deda51220c9cb221.jpg";